import * as _ from 'lodash';

/**
 * Objeto que controla o estado de paginação.
 *
 * O objeto é imutável. Use os métodos para criar uma cópia.
 *
 * Quando a propriedade "size" é alterado, também define "offset" = 0. (ou seja, volta à
 * primeira página).
 *
 */
export class Page {


  constructor() {

    /** Itens por página **/
    this._size = 10;

    /** Offset (0-based) **/
    this._offset = 0;

    /** Quantidade de itens **/
    this._itemCount = 0
  }

  build(){
    return {
      pageSize: this.size(),
          pageNumber: this.page()
    }
  }

  size(size) {
    if (size === undefined)
      return this._size;
    else {
      let x = _.clone(this);
      x._size = size;
      x._offset = 0;
      return x;
    }
  }

  offset(offset) {
    if (offset === undefined) {
      return this._offset;
    } else {
      let x = _.clone(this);
      x._offset = offset;
      return x;
    }
  }

  itemCount(count) {
    if (count === undefined) {
      return this._itemCount;
    } else {
      let x = _.clone(this);
      x._itemCount = count;
      return x;
    }
  }

  pages() {
    let start = this.page() - 5;
    let end = this.page() + 4;
    while (start < 1) {
      start++;
    }

    while (end - start < 9) {
      end++;
    }

    while (end > this.pageCount()) {
      end--;
    }

    return _.range(start, end + 1);
  }

  /**
   * @return {number} número do primeiro registro exibido (1-based)
   */
  firstIndexShown() {
    if(this._itemCount==0)
      return 0;

    return this.offset() + 1
  }

  /**
   * @return {number} número do último registro exibido (1-based)
   */
  lastIndexShown() {
    return Math.min(this.offset() + this.size(), this.itemCount());
  }

  /**
   * @param {number?} page Número da página (1-based).
   * @return {number} Número da página (1-based) ou cópia com valor definido.
   */
  page(page) {
    if (page === undefined) {
      return Math.floor(this.offset() / this.size()) + 1;
    } else {
      return this.offset(this.size() * (page - 1));
    }
  }

  /**
   * @param {number?} pages Numero de páginas
   * @return {number} Número de páginas
   */
  pageCount(pages) {
    if (pages === undefined) {
      return Math.ceil(this.itemCount() / this.size());
    } else {
      return this.itemCount(pages * this.size());
    }
  }
}

const template = require('./pagination.html');

export default {
  template,

  props: ['model'],

  methods: {
    previous() {
      let page = this.model.page();
      if (page > 1) {
        this.$emit('page-change', page - 1);
      }
    },

    next() {
      let page = this.model.page();
      if (page < this.model.pageCount()) {
        this.$emit('page-change', page + 1);
      }
    },

    toPage(p) {
      if (p > 0 && p <= this.model.pageCount()) {
        this.$emit('page-change', p);
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/components/pagination.js